import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import {
  LgBreadcrumbComponent,
  LgBreadcrumbItemComponent,
  LgBreadcrumbItemEllipsisComponent,
  LgGridContainerDirective
} from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { LinkComponent } from "../Link/Link.component";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-breadcrumbs",
  templateUrl: "./Breadcrumbs.component.html",
  styleUrl: "./Breadcrumbs.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LinkComponent,
    LgBreadcrumbComponent,
    LgGridContainerDirective,
    LgBreadcrumbItemEllipsisComponent,
    LgBreadcrumbItemComponent,
    NgClass
  ]
})
export class BreadcrumbsComponent implements DynamicComponent, OnInit {
  @Input() data!: CmsData;

  breadcrumbsItems: any;

  currentActive = -1;
  pageTitle = "";
  isLongList = false;

  pageTitle$: Observable<string> = this.store.select(selectPageTitle);

  constructor(
    private analyticsService: AnalyticsService,
    private store: Store<{ global: GlobalState }>
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  ngOnInit() {
    if (this.data && this.data["breadcrumbsItems"]) {
      this.breadcrumbsItems = this.data["breadcrumbsItems"];

      if (this.breadcrumbsItems.length > 3) {
        this.isLongList = true;
      }

      if (this.isLongList) {
        this.breadcrumbsItems = this.breadcrumbsItems
          .slice(0, 1)
          .concat(this.breadcrumbsItems.slice(-2));
      }
    }
  }

  interactionClickEvent(clickUrl: any, clickName: any) {
    this.analyticsService.adobeInteractionEvent(
      "Breadcrumb Block",
      clickUrl,
      clickName,
      "",
      "LinkClick",
      this.pageTitle,
      ""
    );
  }
}
